import { createTheme as x } from "./ghl-ui.es827.js";
import u from "./ghl-ui.es1146.js";
import H from "./ghl-ui.es1133.js";
import B from "./ghl-ui.es1141.js";
import { changeColor as I } from "./ghl-ui.es863.js";
const T = (r) => {
  const {
    primaryColor: o,
    textColor2: e,
    dividerColor: t,
    hoverColor: i,
    popoverColor: n,
    invertedColor: l,
    borderRadius: p,
    fontSizeSmall: d,
    fontSizeMedium: C,
    fontSizeLarge: v,
    fontSizeHuge: a,
    heightSmall: m,
    heightMedium: g,
    heightLarge: h,
    heightHuge: c,
    textColor3: f,
    opacityDisabled: s
  } = r;
  return Object.assign(Object.assign({}, u), {
    optionHeightSmall: m,
    optionHeightMedium: g,
    optionHeightLarge: h,
    optionHeightHuge: c,
    borderRadius: p,
    fontSizeSmall: d,
    fontSizeMedium: C,
    fontSizeLarge: v,
    fontSizeHuge: a,
    // non-inverted
    optionTextColor: e,
    optionTextColorHover: e,
    optionTextColorActive: o,
    optionTextColorChildActive: o,
    color: n,
    dividerColor: t,
    suffixColor: e,
    prefixColor: e,
    optionColorHover: i,
    optionColorActive: I(o, {
      alpha: 0.1
    }),
    groupHeaderTextColor: f,
    // inverted
    optionTextColorInverted: "#BBB",
    optionTextColorHoverInverted: "#FFF",
    optionTextColorActiveInverted: "#FFF",
    optionTextColorChildActiveInverted: "#FFF",
    colorInverted: l,
    dividerColorInverted: "#BBB",
    suffixColorInverted: "#BBB",
    prefixColorInverted: "#BBB",
    optionColorHoverInverted: o,
    optionColorActiveInverted: o,
    groupHeaderTextColorInverted: "#AAA",
    optionOpacityDisabled: s
  });
}, A = x({
  name: "Dropdown",
  common: H,
  peers: {
    Popover: B
  },
  self: T
}), w = A;
export {
  w as default,
  T as self
};
